// eslint-disable-next-line import/no-anonymous-default-export
module.exports = exports = {

    DIRECTIONS: {
        "1": "Forward",
        "0": "Backward"
    },

    OPERATION_STATUS_REVERSE_MAP: {
        "FAILED": 0,
        "SUCCESSFUL": 1,
        "REJECTED": 2,
        "ACKNOWLEDGED": 3,
        "ABORTED": 4,
        "CANCELLED": 5
    },

    OPERATION_STATUSES: {
        0: "FAILED",
        1: "SUCCESSFUL",
        2: "REJECTED",
        3: "ACKNOWLEDGED",
        4: "ABORTED",
        5: "CANCELLED"
    },

    TASK_STATUSES: {
        "1": "In Queue",
        "2": "In Progress",
        "3": "Completed",
        "4": "Failed",
        "5": "Aborted",
        "6": "Aborted Due to Disconnection",
        "10": "Cancelled",
        "11": "Picked up",
        "12": "Ready To Send",
    },

    TASK_STATUSES_REVERSE_MAP: {
        "IN_QUEUE": 1,
        "IN_PROGRESS": 2,
        "COMPLETED": 3,
        "FAILED": 4,
        "ABORTED": 5,
        "ABORTED_DUE_TO_DISCONNECTION": 6,
        "CANCELLED": 10,
        "PICKED_UP": 11,
        "READY_TO_SEND": 12,
    },

    OPERATIONS: {
        "11": "Dispense",
        "12": "Dispense with Feedback",
        "14": "Dispense To And Fro With Feedback", 
        "16": "Stop Dispense",
        "13": "Agitation",
        "15": "Periodic Agitation On", 
        "18": "Periodic Agitation Off", 
        "300": "Collector Home",
        "301": "Pick Pre-filled Plate",
        "302": "Pick Empty Plate",
        "303": "Place Plate",
        "310": "Move Collector",
        "311": "Move Collector in Pattern",
        "312": "Place Plate in Microwave",
        "313": "Pick Plate from Microwave",
        "314": "Move Collector to Level 1 Docking Position",
        "315": "Move Collector to Level 0 Docking Position",
        "317": "Clear Collector Error",
        "318": "Move Collector to Safe Point",
        "319": "Move Collector to Safe Point from Error",
        "320": "Move Gantry to Microwave Position",
        "500": "Auto Home",
        "501": "Auto Serve",
        "502": "Auto Zero",
        "21": "Push Plate",
        "22": "Move Shutter Up",
        "23": "Move Shutter Down",
        "24": "Move Pusher Forward",
        "25": "Move Pusher Backward",
        "231": "Reset",
        "50": "Send Load Weight",
        "52": "Get Load Cell Weight",
        "53": "Get Load Cell Total Weight",
        "54": "Check Weight in Range",
        "55": "Check Total Weight in Range",
        "51": "Tare",
        "56": "Initialize Load Cell",
        "71": "Lighten Up Progress Bar",
        "73": "Reinitialize and Lighten Up Progress Bar",
        "74": "Set Progress Bar",
        "201": "Check Base Plate",
        "202": "Check Item Dispensed",
        "203": "Upload Image to Drive",
        "210": "Move to Camera Position",
        "211": "Move After Camera Position",
        "220": "Move to Thermal Camera Position",
        "221": "Take Thermal Image",
        "222": "Move After Thermal Camera Image Position",
        "999": "Display",
        "101": "Update Board Files",
        "100": "OTA",
        "450": "Move Collector to Coordinates",
        "451": "Move Mixer to Coordinates",
        "452": "Move Gantry to Cleaning Position",
        "41": "Microwave Heat",
        "42": "Microwave Open",
        "43": "Microwave Close",
        "33": "Wait Till Empty",
        "37": "Dispose",
        "38": "Collect", 
        "39": "Wait Till Empty",
        "121": "Compressor On",
        "122": "Compressor Off",
        "251": "Turn Off Machine",
        "252": "Turn On Machine",
        "81": "Open Door",
        "92": "Move QPD to Slot",
        "93": "Check Plate in QPD After Push",
        "96": "Collect QPD",
        "99": "Dispose QPD",
        "28": "DI Operation Wait Till Empty",
        "30": "DI Set Busy",
        "118": "Check QPD Busy",
        "32": "Check if DI Ready",
        "995": "Send OTP"
    }
    
}